<section class="pt-4">
  <div class="container">
    <h4 class="display-8 mb-4">{{ title }}</h4>
    <ng-content></ng-content>
  </div>
</section>
